// extracted by mini-css-extract-plugin
export var background = "newsBanner-module--background--ba436";
export var button = "newsBanner-module--button--9512e";
export var wrapper = "newsBanner-module--wrapper--912a0";